/** @format */

import { useTranslation } from "react-i18next";
import { Locale } from "../../features/i18n/init";
import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

export const LocaleWrapper = () => {
	const { locale } = useParams<{ locale: Locale }>();
	const { i18n } = useTranslation();

	useEffect(() => {
		if (locale === "en" || locale === "cy") {
			i18n.changeLanguage(locale);
			localStorage.setItem("locale", locale);
		}
	}, [locale, i18n]);

	if (locale !== "en" && locale !== "cy") {
		return <Navigate to="/en" replace />;
	}

	return <Outlet />;
};
